module.exports = __webpack_public_path__ + "fonts/sunflower-medium-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Sunflower/sunflower-medium-webfont.woff2
// module id = 3464
// module chunks = 0